import { toast } from 'react-toastify';
import NotificationToast from '../../notifications/components/notification-toast';

export function successToast(message: string): void {
  toast.success(message, {});
}

export function errorToast(message: string): void {
  toast.error(message, {});
}

export function successToastNotification(
  message: string,
  action: boolean
): void {
  toast(<NotificationToast message={message} action={action} />);
}
